// @flow

import { decimalFormatter } from '@tectonics/look-and-feel/commons/format-utils';
import { type Country } from '@tectonics/prs/country';
import { type FormatDecimal } from '@tectonics/prs/money';

const LATAM_FORMAT = decimalFormatter({
  thousandsSeparator: '.',
  decimalSeparator: ',',
});

export function getMoneyFormat(country: Country): FormatDecimal {
  return LATAM_FORMAT;
}
